import { push } from "connected-react-router";
import PropTypes from "prop-types";
import React from "react";
import { connect } from "react-redux";

import { roles } from "../actions";
import RoleFilter from "../components/RoleFilter";
import { RoleShape } from "../proptypes";

const RoleHeading = ({ roles, filterRole, push, setCurrentRole }) => {
  const openRoles = uri => {
    if (uri) {
      setCurrentRole(uri);
    }
    push("/policies/roles");
  };

  return (
    <div>
      <button
        type="button"
        className="p-button--link p-muted-heading"
        onKeyPress={() => openRoles(roles.length && roles[0].$uri)}
        onClick={() => openRoles(roles.length && roles[0].$uri)}
      >
        Roles
      </button>
      &nbsp;
      <RoleFilter roles={roles} filterRole={filterRole} />
    </div>
  );
};

RoleHeading.propTypes = {
  roles: PropTypes.arrayOf(RoleShape).isRequired,
  filterRole: PropTypes.func.isRequired,
  push: PropTypes.func.isRequired,
  setCurrentRole: PropTypes.func.isRequired
};

const mapDispatchToProps = {
  push,
  setCurrentRole: roles.setCurrent
};

export default connect(
  null,
  mapDispatchToProps
)(RoleHeading);
